const cloneArray = arr => {
  return JSON.parse(JSON.stringify(arr));
}

export default cloneArray